import { useBuildStore } from '@apparatix/stores/useBuildStore';

/**
 * Contract handshake with App\Http\Middleware\EnforceClientContract.
 *
 * Every request the shell makes carries the contract version this tab loaded
 * with. If a deploy has since declared that older clients are incompatible, the
 * server answers 426 and the shell escalates to a mandatory reload — so a stale
 * tab is stopped before a bad write rather than after one.
 */
export const CONTRACT_HEADER = 'X-Apx-Contract';

/** Set by the middleware, so we don't mistake an unrelated 426 for a stale client. */
export const CONTRACT_REJECTION_HEADER = 'x-apx-contract-required';

export const CONTRACT_REJECTED_STATUS = 426;

/**
 * The contract header, or nothing if this context has no contract to claim.
 *
 * The legacy design boots the same AppFactory (`init(false)`) but never mounts
 * `Pages/App.vue`, so it never receives the Inertia props that seed the
 * contract. Claiming `0` there would put every legacy request below the minimum
 * and have it rejected. Sending no header is both truthful and safe — the
 * middleware only enforces against clients that actually declare a version.
 */
export const contractHeader = (): Record<string, string> => {
  const { bootContract } = useBuildStore();

  return bootContract > 0 ? { [CONTRACT_HEADER]: String(bootContract) } : {};
};
